export const preloadImage = (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve();
    i.onerror = () => reject(new Error("Image load error"));
    i.src = url;
  });
};
